import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import Http from "./Http";
import { isPrivilegedUser } from "./permissions";

// Route guard that only renders its children for privileged users (admins and
// department heads). Normal members are redirected away. Used for the task
// calendars, which normal members should not access.
const PrivilegedRoute = ({ children, redirectTo = "/list-task" }) => {
  const [status, setStatus] = useState("loading"); // loading | allowed | denied

  useEffect(() => {
    let active = true;
    Http.get("/me")
      .then((res) => {
        const user = res.data?.data || res.data;
        if (active) setStatus(isPrivilegedUser(user) ? "allowed" : "denied");
      })
      .catch(() => {
        if (active) setStatus("denied");
      });
    return () => {
      active = false;
    };
  }, []);

  if (status === "loading") {
    return (
      <div className="text-center p-5">
        <ProgressSpinner />
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PrivilegedRoute;
